module.exports = __webpack_public_path__ + "img/tab2.81937277.png";